var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$attrs.type == 'spacer')?_c('div'):(_vm.$attrs.type == 'divider')?_c('div',[_c('hr')]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }